import React, { ReactElement, SyntheticEvent } from 'react';
import styled from 'styled-components';
import {
  layout,
  LayoutProps,
  space,
  SpaceProps,
  FlexProps,
  PositionProps,
} from 'styled-system';

import { StyledFormInput } from '../../components/textInput';

import * as Icon from '../../../assets/icons';

type StyledSearchInputWrapperProps = LayoutProps &
  SpaceProps &
  FlexProps &
  PositionProps;

const StyledSearchInputWrapper = styled.div<StyledSearchInputWrapperProps>`
  ${space}
  ${layout}

    position: relative;

  & .pr-icon {
    position: absolute;
    left: 0.714em;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;

    svg {
      width: 1.2em;
      height: 1.2em;

      path {
        fill: var(--high-contrast-neutral);
      }
    }
  }

  input[type='search'] {
    padding-left: ${({ theme }) => theme.space[7]};
    /* height: auto; */

    ::-webkit-search-cancel-button {
      -webkit-appearance: none;
      height: 20px;
      width: 20px;
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z' fill='%2300000080'/%3E%3C/svg%3E");

      html[data-color-mode='dark'] & {
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z' fill='%23FFFFFF80'/%3E%3C/svg%3E");
      }

      &:hover {
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z' fill='%23000000CC'/%3E%3C/svg%3E");

        html[data-color-mode='dark'] & {
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z' fill='%23FFFFFFE6'/%3E%3C/svg%3E");
        }
      }
    }
  }
`;

type SearchInputProps = StyledSearchInputWrapperProps & {
  label?: string | any;
  value?: string;
  onTextChange?: (text: string) => void;
  type?: 'email' | 'number' | 'password' | 'search' | 'text' | 'tel' | 'url';
  placeholder?: string;
  disabled?: boolean;
  validation?: string;
  feedback?: string;
  required?: boolean;
  handleChange?: (value: string) => void;
};

function SearchInput({
  value,
  placeholder,
  disabled,
  validation,
  handleChange,
  ...StyledSearchInputWrapperProps
}: SearchInputProps): ReactElement {
  return (
    <StyledSearchInputWrapper {...StyledSearchInputWrapperProps}>
      <Icon.Search />
      <StyledFormInput
        type="search"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        validation={validation}
        onChange={(e: SyntheticEvent<HTMLInputElement>) =>
          handleChange && handleChange(e.currentTarget.value)
        }
      />
    </StyledSearchInputWrapper>
  );
}

export { SearchInput };
